"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

require("../styles/_organisation-loading.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var CARD_HEIGHT = 200;

function Loading(_ref) {
  var containerWidth = _ref.size.width;
  var CARD_WIDTH = containerWidth > 500 ? 400 : 300;
  var numLoadingItems = Math.floor(containerWidth / CARD_WIDTH);

  var arrayOfItems = _toConsumableArray(new Array(numLoadingItems));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "organisation-loading"
  }, arrayOfItems.map(function (value, index) {
    return (
      /*#__PURE__*/
      // Special case okay to use index as key here
      // eslint-disable-next-line react/no-array-index-key
      _react.default.createElement("div", {
        key: index,
        style: {
          width: "".concat(CARD_WIDTH, "px"),
          height: "".concat(CARD_HEIGHT, "px")
        }
      }, /*#__PURE__*/_react.default.createElement(_commonReact.ContentLoader, {
        height: "200",
        width: "400"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: "10",
        y: "0",
        rx: "0",
        ry: "0",
        width: "100",
        height: "100"
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "135",
        y: "20",
        rx: "4",
        ry: "4",
        width: "175",
        height: "20"
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "135",
        y: "60",
        rx: "4",
        ry: "4",
        width: "245",
        height: "10"
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "135",
        y: "80",
        rx: "4",
        ry: "4",
        width: "245",
        height: "10"
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "10",
        y: "115",
        rx: "4",
        ry: "4",
        width: "368",
        height: "10"
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "10",
        y: "135",
        rx: "4",
        ry: "4",
        width: "368",
        height: "10"
      })))
    );
  }));
}

var _default = (0, _react.memo)(Loading);

exports.default = _default;